export const BATTLE = '[BATTLE]'
export const INIT_BATTLE = `${BATTLE} Initialise Battle Stage`
export const PROGRESS_BATTLE = `${BATTLE} Progress to next Battle Step`
export const SET_BATTLE_BANNER = `${BATTLE} Set current Battle Banner`
export const RESET_BATTLE = `${BATTLE} Reset Battle Stage`

export const initBattle = (squadUnits, stage) => ({
    type: INIT_BATTLE,
    payload: {
        squadUnits,
        stage,
    },
    meta: {
        battleStage: 'init',
    },
})

export const setBattleBanner = banner => ({
    type: SET_BATTLE_BANNER,
    payload: { banner },
})

export const progressBattle = () => ({
    type: PROGRESS_BATTLE,
    payload: {},
    meta: {
        battleStage: 'nextStep',
    },
})

export const resetBattle = () => ({
    type: RESET_BATTLE,
    payload: {},
    meta: {
        battleStage: 'reset',
    },
})
